import como2 from '../video/como2.jpg';
import como1 from '../video/como1.jpg';
import aa from '../video/aa.jpg';
import alu from '../video/alu.jpg';
import re from '../video/re.jpg';
import give from '../video/give.jpg';
import an from '../video/an.jpg';
import design_128 from '../video/design_128.png'
import code_128 from '../video/code_128.png'
import launch_128 from '../video/launch_128.png'
import tra12 from '../video/tra12.jpg'
import tra13 from '../video/tra13.jpg'
import tra14 from '../video/tra14.jpg'
import tra15 from '../video/tra15.jpeg'
import muba from '../video/muba.jpg'
import d9 from '../video/d9.jpg'
import akm from '../video/akm.jpg'
import spicy from '../video/spicy.jpg'
import pally from '../video/pally.jpg'
import am1 from '../video/am1.jpg'
import am2 from '../video/am2.jpg'
import am3 from '../video/am3.jpg'
import am4 from '../video/am4.jpg'
import am5 from '../video/am5.jpg'
import am6 from '../video/am6.jpg'
import am7 from '../video/am7.jpg'
import am9 from '../video/am9.jpg'
import am10 from '../video/am10.jpg'
import am11 from '../video/am11.jpg'
import am21 from '../video/am21.jpg'
import am13 from '../video/am13.jpg'
import am22 from '../video/am22.jpg'
import am15 from '../video/am15.jpg'
import am16 from '../video/am16.jpg'
import am19 from '../video/am19.jpg'
import ram2 from '../video/ram2.jpg'
import am23 from '../video/am23.jpg'
import ex1 from '../video/ex1.jpg'
import sk from '../video/sk.jpg'
import skl from '../video/skl.jpg'
import pay1 from '../video/pay1.jpg'
import pay2 from '../video/pay2.jpg'
import pay3 from '../video/pay3.jpg'
import ver from '../video/ver.jpg'
import verr from '../video/verr.jpg'


const images ={
    pay1,
    pay2,
    pay3,
    ex1,
    am1,
    am2,
    am3,
    am4,
    am5,
    am6,
    am7,
    am9,
    am10,
    am11,
    am21,
    am13,
    am22,
    am23,
    am15,
    am16,
    am19,
    sk,
    como1,
    como2,
    aa,
    alu,
    give,
    re,
    an,
    design_128,
    code_128,
    launch_128,
    tra12,
    tra13,
    tra14,
    tra15,
    muba,
    d9,
    akm,
    pally,
    ram2,
    spicy,
    skl,
    ver,
    verr
   
};

function getImageByKey(key){
    return images[key];
}

export default getImageByKey;

